/* eslint-disable no-param-reassign */
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import env from '@beam-australia/react-env';
import { GET_COLLECTION_ITEMS_BY_PROPERTY } from '../../graphql/query/collectionItem';

const useStyles = makeStyles((theme) => ({
  list: {
    listStyleType: 'none',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    margin: 0,
  },
  listItem: {
    margiTop: theme.spacing(2),
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const CollectionItemsListContainer = (props) => {
  const { property } = props;
  const propertyId = parseInt(property?.collectionTypeProperty?.id, 10) || null;
  const classes = useStyles();

  if (!propertyId) {
    return <div className={classes.list}>No items available for this property.</div>;
  }

  const { data, loading } = useQuery(GET_COLLECTION_ITEMS_BY_PROPERTY, {
    variables: {
      filterProperties: [
        {
          propertyId,
          propertyValues: [property.id],
        },
      ],
      limit: 25,
      next: null,
    },
  });

  const results = data?.collectionItems?.results || [];

  if (loading) {
    return <div className={classes.list}>Loading items...</div>;
  }

  if (!results.length) {
    return <div className={classes.list}>No items found for this property.</div>;
  }

  return (
    <ul className={classes.list}>
      {results.map((item) => (
        <li key={item.id} className={classes.listItem}>
          <a
            href={`${env('SITE_URL')}/?slug=${item.slug}&modalType=item`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            {item.name}
          </a>
        </li>
      ))}
    </ul>
  );
};

CollectionItemsListContainer.propTypes = {
  property: PropTypes.any,
};

CollectionItemsListContainer.defaultProps = {
  property: null,
};

export default CollectionItemsListContainer;
